import React, { useEffect } from "react"

import { I18nProvider } from "@lingui/react"

import { i18n, Messages } from "@lingui/core"
import { Locale } from "../format/localization"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type I18nCatalog = { messages: Record<string, any> }

export const LinguiProvider: React.FC<React.PropsWithChildren<{ locale: Locale; i18nCatalog: I18nCatalog }>> = ({
    children,
    locale,
    i18nCatalog,
}) => {
    const messages = i18nCatalog.messages
    useLinguiInit(messages, locale)

    return <I18nProvider i18n={i18n}>{children}</I18nProvider>
}

// export async function loadCatalog(locale: string) {
//     const catalog = await import(`@lingui/loader!./locales/${locale}.po`)
//     return catalog.messages
// }

// from https://github.com/lingui/js-lingui/tree/main/examples/nextjs-swc
export function useLinguiInit(messages: Messages, locale: Locale) {
    //const router = useRouter()
    //const locale = router.locale || router.defaultLocale!
    const isClient = typeof window !== "undefined"

    if (!isClient && locale !== i18n.locale) {
        // there is single instance of i18n on the server
        // note: on the server, we could have an instance of i18n per supported locale
        // to avoid calling loadAndActivate for (worst case) each request, but right now that's what we do
        i18n.loadAndActivate({ locale, messages })
    }
    if (isClient && !i18n.locale) {
        // first client render
        i18n.loadAndActivate({ locale, messages })
    }

    useEffect(() => {
        const localeDidChange = locale !== i18n.locale
        if (localeDidChange) {
            i18n.loadAndActivate({ locale, messages })
        }
    }, [locale])

    return i18n
}
